export interface ChatMessage {
    role: string,
    content: string
}

export interface ChatFileChunk {
    user_id: string;
    file_id: string,
    file_name: string,
    is_last: boolean,
    chunk: string,
    message?: string
}

export enum ChatEventTypes {
    chatComplete = 'chat_complete',
    chatMessage = 'chat_message',
    fileChunk = 'file_chunk',
    chatError = 'error'
}

export enum AcknowledgementTypes {
    aiChat = 'ai_chat'
}

export interface UserAcknowledgementResponse {
    status: boolean,
    message: string,
    data: {
        user_id: string,
        type: AcknowledgementTypes,
        acknowledge: boolean,
        first_answered: string,
        updated_at: string
    }
}

export interface SuggestedPromptsResponse {
    status: boolean,
    message: string,
    data: {
        suggested_prompts: SuggestedPrompt[]
    }
}

export interface SuggestedPrompt {
    id: string,
    account_id: string,
    prompt: string,
    timestamp: string,
    metadata: object
}
